import { combineReducers } from 'redux'

import authReducer from './authReducer'
import errorReducer from './errorReducer'
import toastReducer from './toastReducer'
import talentsReducer from './talentsReducer'
import modalReducer from './modalReducer'
import jobPostingReducer from './jobPostingReducer'
import listsReducer from './listsReducer'
import recruiterReducer from './requisitionReducer'
import clientReducer from './clientsReducer'
import skillsReducer from './skillsReducer'
import jobListingReducer from './jobListingReducer'
import usersReducer from './usersReducer'
import userTypeReducer from './userTypeReducer'
import sidebarModuleReducer from './sidebarModuleReducer'
import emailTemplatesReducer from './emailTemplatesReducer'
import dashboardReducer from './dashboardReducer'
import ratingReducer from './ratingReducer'
import tabReducer from './tabReducer'

const reducers = combineReducers({
  auth: authReducer,
  clients: clientReducer,
  error: errorReducer,
  toast: toastReducer,
  talents: talentsReducer,
  modal: modalReducer,
  jobListing: jobListingReducer,
  jobPosting: jobPostingReducer,
  lists: listsReducer,
  requisitions: recruiterReducer,
  skills: skillsReducer,
  users: usersReducer,
  userTypes: userTypeReducer,
  sidebarModules: sidebarModuleReducer,
  emailTemplates: emailTemplatesReducer,
  dashboard: dashboardReducer,
  ratings: ratingReducer,
  tabs: tabReducer,
})

export default reducers
